export enum GRAPHIC_OBJECT_FIELDS {
  GLOBAL = 'global',
  LINE = 'line',
  CONNECTION = 'connection',
  FLOATING = 'floating',
  REFERENCE_SYSTEM = 'referenceSystem',
}
